<template>
  <van-action-sheet v-model="returnNumber" title="" @close="close">
    <div class="header">
      <div class="title">拒绝原因</div>
      <div class="close">
        <van-icon name="cross" @click="close" />
      </div>
    </div>
    <div class="return_box">
      <!-- 自定义原因 -->
      <van-checkbox-group v-model="checkboxGroup" direction="horizontal" @change="checkboxChange">
        <van-checkbox name="超出诊疗范围">超出诊疗范围</van-checkbox>
        <van-checkbox name="受者自身原因">受者自身原因</van-checkbox>
      </van-checkbox-group>
      <!-- 其他原因 -->
      <div class="other_reason">
        <span class="title">其他原因：</span>
        <textarea
          v-model="returnNoDesc"
          maxlength="200"
          :always-embed="true"
          placeholder="请输入拒绝原因"
          placeholder-style="color:#CECECE;font-size:30upx"
          placeholder-class="textarea-placeholder"
          :show-confirm-bar="false"
        ></textarea>
      </div>
    </div>
    <div class="outer">
      <div class="bottom">
        <div class="footer-box" @click="close">
          <span class="btn">放弃</span>
        </div>
        <div class="confirm-box" @click="confirm">
          <span class="btn con">确定</span>
        </div>
      </div>
    </div>
  </van-action-sheet>
</template>

<script>
import { retreatOperate } from '../../utils/index.js'
import { mapState } from 'vuex'
import { Toast } from 'vant'

export default {
  data() {
    return {
      returnNumber: false,
      checkboxGroup: [],
      returnNoDesc: '',
      checkReason: '',
      showTip: false
    }
  },
  props: {
    visitID: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('user', ['userInfos'])
  },
  methods: {
    open(val) {
      this.returnNumber = val
    },
    confirm() {
      // 退号原因必填校验
      if (this.checkReason.split('').length === 0 && !this.returnNoDesc) {
        Toast.fail('请说明拒绝原因')
        return
      }

      const checkReason = this.checkReason ? `${this.checkReason}。` : ''

      const params = {
        hospitalID: this.userInfos.hospitalID,
        visitID: this.visitID,
        returnNoDesc: `${checkReason}${this.returnNoDesc}`,
        doctorID: this.userInfos.doctorID
      }

      // 调用退号接口
      retreatOperate(params)
        .then(res => {
          // 关闭退号原因弹窗
          this.close()
          if (!res.code) {
            this.$emit('returnLast')
            return
          }
          Toast.fail(res.codeDesc)
        })
        .catch(error => {})
    },
    checkboxChange() {
      // 拼接原因
      this.checkReason = this.checkboxGroup.join('，')
    },
    close() {
      // 关闭退号弹窗
      // 关闭弹窗的时候清空填写的原因
      this.returnNoDesc = ''
      this.checkboxGroup = []
      this.returnNumber = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding: 0.426667rem 0.661333rem;
  display: FLEX;
  align-items: center;
  .title {
    flex: 1;
    font-size: 0.768rem;
    line-height: 1.856rem;
    color: #222;
  }
  .close {
    flex: 0 0 auto;
  }
}

.return_box {
  box-sizing: border-box;
  padding: 0.64rem;
  .other_reason {
    margin-top: 1.322667rem;
    font-size: 0.64rem;
    font-weight: 400;
    color: #222222;
    .title {
      margin-bottom: 0.512rem;
      display: block;
    }
    textarea {
      display: block;
      width: 100%;
      height: 2.56rem;
      border: none;
    }
  }
}
.outer {
  border-top: 0.021333rem solid #ececec;
  padding: 0 0.64rem;
  .bottom {
    display: flex;
    justify-content: space-between;
    padding-top: 0.384rem;
    padding-bottom: 0.384rem;
    box-sizing: border-box;
    .footer-box,
    .confirm-box {
      text-align: center;
      width: 6.976rem;
      height: 1.877333rem;
      background: #ffffff;
      border-radius: 0.938667rem;
      border: 0.021333rem solid #0089ff;
      line-height: 1.877333rem;
      font-size: 0.682667rem;
      font-weight: 500;
      .btn {
        color: #0089ff;
      }
      .con {
        color: #fff;
      }
    }
    .confirm-box {
      background-color: #0089ff;
    }
    .oneperson_style {
      width: 14.634667rem;
    }
  }
}
</style>
